//Core
import React from "react"

//Components
import Layout from "../../container/Layout"
import Bonus from "../../modules/bonus"
import Banner from "../../components/Banner"

//Styles
import "../../styles/main.scss"

const Bonus200 = () => (
  <Layout
    title={`АКЦІЯ: тільки для вас бонус 200 грн!`}
    description={`Поспішайте отримати персональний бонус за будь-які покупки або зняття готівки вашою карткою ТАСКОМБАНК`}
    link={`https://tascombank.ua/promo/bonus200/`}
  >
    <Banner></Banner>
    <Bonus
      bonus={"200"}
      link={`https://tascombank.ua/files/Ofitsiini_pravyla_aktsii_novorichnyi_velkom_200_12.pdf`}
    ></Bonus>
  </Layout>
)

export default Bonus200
